import React from "react";
import { useNavigate } from "react-router-dom";
import notFoundImg from "../../assets/notFound.webp";
import DownloadIcon from "../../assets/download.svg";
import "./NotFound.css";

export default function NotFound() {
    const navigate = useNavigate();
    return (
        <>
            <title>404: Page Not Found | Oakmate</title>
            <meta
                name="description"
                content="Sorry, the page you were looking for could not be found. Return to the Oakmate homepage."
            />
            <div className="notfound">
                <img
                    src={notFoundImg}
                    alt="In Construction"
                    className="inConstructionImg"
                />
                <div className="inConstruction-title">
                    Looks like this page castled the wrong way! (404)
                </div>
                <div className="inConstruction-subtitle">
                    In the meantime, check out our Chrome extension — it works
                    right on chess.com.
                </div>
                <button
                    className="download-cta"
                    onClick={() => {
                        navigate("/download");
                    }}
                >
                    <div className="download-cta-text">Download</div>
                    <img
                        src={DownloadIcon}
                        className="download-cta-icon"
                        alt="Download Icon"
                    />
                </button>
                <button className="back-to-home" onClick={() => navigate("/")}>
                    Back to home page
                </button>
            </div>
        </>
    );
}
